import { render, staticRenderFns } from "./MatterDamagesClaimForm.vue?vue&type=template&id=ba63fc42&"
import script from "./MatterDamagesClaimForm.vue?vue&type=script&lang=js&"
export * from "./MatterDamagesClaimForm.vue?vue&type=script&lang=js&"
import style0 from "./MatterDamagesClaimForm.vue?vue&type=style&index=0&id=ba63fc42&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports